import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KnowledgeAssetTagAppResource from './KnowledgeAssetTagAppResource';
import StageTypeAppResource from "./StageTypeAppResource";
import KnowledgeAssetCategoryAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/KnowledgeAssetCategoryAppResource";


class KnowledgeAssetAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Knowledge-Asset';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'knowledge/assets';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'knowledgeBaseUuid',
            'tags',
            'stages',
            'isPublished',
            'categories',
            'categoriesOptional',
            'type',
            'isHohFeatured',
            'isHsFeatured',
            'isHpFeatured',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            tags: KnowledgeAssetTagAppResource,
            stages: StageTypeAppResource,
            categories: KnowledgeAssetCategoryAppResource,
            categoriesOptional: KnowledgeAssetCategoryAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            tags: {
                type: 'array'
            },
            stages: {
                type: 'array'
            },
        };
    }

    getVimeoLink() {
        if (!this.vimeoLink) {
            return null;
        }
        let vimeoId = this.vimeoLink.match(/\d/g).join("");
        return `https://player.vimeo.com/video/${vimeoId}?portrait=0&byline=0&title=0`;
    }
}

export default KnowledgeAssetAppResource;
